import { jsonpRequest } from '../../utils/jsonp';

const API_KEY = process.env.REACT_APP_VWORLD_API_KEY || '';

export interface LandCharacteristicsResponse {
  ladfrlVOList: {
    pageNo: string;
    ladfrlVOList: Array<{
      lndpclAr: string; // 토지면적(㎡) - 문자열로 반환됨
      lndcgrCodeNm: string; // 지목명 (예: "대")
      ldCodeNm: string; // 지역명 (예: "경기도 성남시 수정구 고등동")
      ldCode: string;
      ladFrtlScNm: string;
      posesnSeCode: string;
      mnnmSlno: string;
      lndcgrCode: string;
      cnrsPsnCo: string;
      ladFrtlSc: string;
      pnu: string;
      posesnSeCodeNm: string; // 소유구분 (예: "국유지")
      lastUpdtDt: string; // 최종수정일
      regstrSeCodeNm: string; // 등록구분 (예: "토지대장")
      regstrSeCode: string;
    }>;
    totalCount: string;
    error: string;
    message: string;
    numOfRows: string;
  };
}

export interface LandAreaInfo {
  landArea: number; // 면적(㎡)
  areaInPyeong: number; // 평수
}

/**
 * VWorld 토지특성조회 API 호출
 * @param pnu PNU 코드
 * @returns 토지특성 정보
 */
export const getLandCharacteristics = async (pnu: string): Promise<LandCharacteristicsResponse> => {
  const params = {
    key: API_KEY,
    pnu,
  };

  try {
    const response = await jsonpRequest('https://api.vworld.kr/ned/data/ladfrlList', params);
    return response;
  } catch (error) {
    console.error('❌ 토지특성조회 API 호출 실패:', error);
    throw error;
  }
};

/**
 * 면적(㎡)을 평수로 변환
 * @param squareMeter 면적(㎡)
 * @returns 평수
 */
export const convertSquareMetersToPyeong = (squareMeter: number): number => {
  if (!squareMeter || squareMeter <= 0) return 0;
  return Math.round((squareMeter / 3.305785) * 100) / 100; // 소수점 둘째자리까지
};

/**
 * 토지특성조회 API 호출 후 면적 정보를 추출하여 반환
 * @param pnu PNU 코드
 * @returns 면적 정보 (㎡, 평수, 표시용 텍스트)
 */
export const getLandAreaInfo = async (pnu: string): Promise<LandAreaInfo | null> => {
  try {
    const landCharacteristics = await getLandCharacteristics(pnu);

    if (landCharacteristics?.ladfrlVOList?.ladfrlVOList?.[0]) {
      const landFeature = landCharacteristics.ladfrlVOList.ladfrlVOList[0];
      const landArea = parseFloat(landFeature.lndpclAr);
      const areaInPyeong = convertSquareMetersToPyeong(landArea);

      return {
        landArea,
        areaInPyeong,
      };
    }

    return null;
  } catch (error) {
    console.error('❌ 토지면적 정보 조회 실패:', error);
    return null;
  }
};
